import {Button, Card, Checkbox, Form, Icon, Input, Spin, Tooltip} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import SubList from "../../components/SubList";

class Create extends React.Component {
  state = {isEnabled: {}, isOverlappedVisible: false, isReminderIntervalVisible: false};

  componentDidMount() {
    const {match, fetch} = this.props;
    if(match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps.data, this.props.data);
    if(nextProps && nextProps.data && JSON.stringify(nextProps.data) !== '{}' && JSON.stringify(this.state.isEnabled) === '{}') {
      // console.log(nextProps.data, this.props.data, this.state.isEnabled);
      if(nextProps.data.isDocumentDateRequired && nextProps.data.isRenewalDateRequired) {
        this.setState({isOverlappedVisible: true})
      }
      if(nextProps.data.isOverlappedDisabled) {
        this.setState({isReminderIntervalVisible: true})
      }
      this.setState({
        isEnabled: {
          isDocumentDateRequired: nextProps.data.isDocumentDateRequired || false,
          isRenewalDateRequired: nextProps.data.isRenewalDateRequired || false,
          isOverlappedDisabled: nextProps.data.isOverlappedDisabled || false,
          // isOverlappedVisible: !!(nextProps.data.isDocumentDateRequired && nextProps.data.isRenewalDateRequired),
          // isReminderIntervalVisible: nextProps.data.isOverlappedDisabled || false,
        }
      });
      // console.log(nextProps.data);
    }
  }


  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if(err) {
        return console.log(err);
      }
      if(!values.isOverlappedDisabled) {
        values.reminderInterval = 0;
      }
      if(match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  handleCheck = (e, type) => {
    // console.log(e.target.checked, type);
    const enabledObject = this.state.isEnabled;
    // console.log(enabledObject);
    if(type === 'isDocumentDateRequired') {
      enabledObject.isDocumentDateRequired = e.target.checked;
    }
    if(type === 'isRenewalDateRequired') {
      enabledObject.isRenewalDateRequired = e.target.checked;
    }
    if(type === 'isOverlappedDisabled') {
      enabledObject.isOverlappedDisabled = e.target.checked;
      // this.setState({isReminderIntervalVisible: e.target.checked});
      if(!e.target.checked) {
        this.props.form.setFieldsValue({reminderInterval: 0});
      }
    }
    // console.log(enabledObject);
    this.setState({
      isEnabled: enabledObject,
      isOverlappedVisible: !!(enabledObject.isDocumentDateRequired && enabledObject.isRenewalDateRequired),
      isReminderIntervalVisible: !!(enabledObject.isDocumentDateRequired && enabledObject.isRenewalDateRequired && enabledObject.isOverlappedDisabled),
    });
    if(!(enabledObject.isDocumentDateRequired && enabledObject.isRenewalDateRequired)) {
      this.props.form.setFieldsValue({reminderInterval: 0});
      // enabledObject.isOverlappedDisabled = false;
    }
    // console.log(this.state);
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form} = this.props;
    // console.log(this.props);
    // console.log(this.state);
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if(filters[item].type === 'Array' && filters[item].schema) {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title}
                                resource={resource}/>
              } else if(item !== 'isDocumentDateRequired' && item !== 'isRenewalDateRequired' && item !== 'isOverlappedDisabled' && item !== 'reminderInterval') {
                return getFormFieldByType(filters, item, getFieldDecorator, data, {title: title, resource})
              }

              if(item === 'isDocumentDateRequired')
                return (<Form.Item key={'isDocumentDateRequired'} label="Is Document Date Required">
                  {getFieldDecorator('isDocumentDateRequired', {
                    rules: [{required: false, message: `Date is required!`}],
                    valuePropName: 'checked',
                    initialValue: !!(data && data['isDocumentDateRequired'])
                  })(<Checkbox onChange={(checked) => this.handleCheck(checked, 'isDocumentDateRequired')}/>)}
                </Form.Item>);

              if(item === 'isRenewalDateRequired')
                return (<Form.Item key={'isRenewalDateRequired'} label="Is Renewal Date Required">
                  {getFieldDecorator('isRenewalDateRequired', {
                    rules: [{required: false, message: `Date is required!`}],
                    valuePropName: 'checked',
                    initialValue: !!(data && data['isRenewalDateRequired'])
                  })(<Checkbox onChange={(checked) => this.handleCheck(checked, 'isRenewalDateRequired')}/>)}
                </Form.Item>);

              if(item === 'reminderInterval' && this.state.isReminderIntervalVisible === true)
                return (<Form.Item key={'reminderInterval'} label={
                  <span>{'Reminder Interval'}&nbsp;
                    {filters[item].options.description ?
                      (<Tooltip title={filters[item].options.description}>
                        <Icon type="question-circle-o"/>
                      </Tooltip>) : null}
                          </span>}>
                  {getFieldDecorator('reminderInterval', {
                    rules: [{required: false, message: `Reminder Interval is required!`}],
                    initialValue: (this.props.form.getFieldValue('reminderInterval') || (data && data['reminderInterval']))
                  })(<Input type='number'/>)}
                </Form.Item>);

              if(item === 'isOverlappedDisabled' && this.state.isOverlappedVisible === true)
                return (<Form.Item key={'isOverlappedDisabled'} label={
                  <span>{"Is Overlapped Disabled"}&nbsp;
                    {filters[item].options.description ?
                      (<Tooltip title={filters[item].options.description}>
                        <Icon type="question-circle-o"/>
                      </Tooltip>) : null}
                          </span>}>
                  {getFieldDecorator('isOverlappedDisabled', {
                    rules: [{required: false, message: `Date is required!`}],
                    valuePropName: 'checked',
                    initialValue: !!(data && data['isOverlappedDisabled'])
                  })(<Checkbox onChange={(checked) => this.handleCheck(checked, 'isOverlappedDisabled')}/>)}
                </Form.Item>);
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
